import { render, staticRenderFns } from "./UNInformationCenter.vue?vue&type=template&id=21abe26e&scoped=true&"
import script from "./UNInformationCenter.vue?vue&type=script&lang=js&"
export * from "./UNInformationCenter.vue?vue&type=script&lang=js&"
import style0 from "./UNInformationCenter.vue?vue&type=style&index=0&id=21abe26e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21abe26e",
  null
  
)

export default component.exports